import React from 'react'

const WriteListIcon = (
  <>
    <path
      d="M8.77154 21.8855H8.12309C7.4341 21.8855 6.90723 22.4529 6.90723 23.1014C6.90723 23.7903 7.47463 24.3172 8.12309 24.3172H8.77154C9.46053 24.3172 9.9874 23.7498 9.9874 23.1014C9.9874 22.4529 9.46053 21.8855 8.77154 21.8855Z"
      fill="#2EB9FF"
    />
    <path
      d="M8.77154 15.6846H8.12309C7.4341 15.6846 6.90723 16.252 6.90723 16.9004C6.90723 17.5489 7.47463 18.1163 8.12309 18.1163H8.77154C9.46053 18.1163 9.9874 17.5489 9.9874 16.9004C9.9874 16.252 9.46053 15.6846 8.77154 15.6846Z"
      fill="#2EB9FF"
    />
    <path
      d="M8.77154 28.1268H8.12309C7.4341 28.1268 6.90723 28.6942 6.90723 29.3427C6.90723 30.0317 7.47463 30.5585 8.12309 30.5585H8.77154C9.46053 30.5585 9.9874 29.9911 9.9874 29.3427C9.9874 28.6942 9.46053 28.1268 8.77154 28.1268Z"
      fill="#2EB9FF"
    />
    <path
      d="M23.038 23.1419C23.038 22.4529 22.4706 21.926 21.8221 21.926H12.9463C12.2573 21.926 11.7305 22.4934 11.7305 23.1419C11.7305 23.8309 12.2979 24.3577 12.9463 24.3577H21.8221C22.5111 24.3577 23.038 23.8309 23.038 23.1419Z"
      fill="#2EB9FF"
    />
    <path
      d="M21.8221 15.6846H12.9463C12.2573 15.6846 11.7305 16.252 11.7305 16.9004C11.7305 17.5489 12.2979 18.1163 12.9463 18.1163H21.8221C22.5111 18.1163 23.038 17.5489 23.038 16.9004C23.038 16.252 22.5111 15.6846 21.8221 15.6846Z"
      fill="#2EB9FF"
    />
    <path
      d="M11.7305 29.3427C11.7305 30.0317 12.2979 30.5585 12.9463 30.5585H19.0662L19.6336 28.0863H12.9463C12.2573 28.1268 11.7305 28.6537 11.7305 29.3427Z"
      fill="#2EB9FF"
    />
    <path
      d="M27.2933 33.5982C27.2933 34.0035 26.9691 34.3683 26.5233 34.3683H3.38145C2.93564 34.3683 2.61141 34.0035 2.61141 33.5982V3.20176C2.61141 2.75595 2.93564 2.43172 3.38145 2.43172H17.8502V8.67313C17.8502 10.4564 19.2687 11.8749 21.0519 11.8749H27.2933V19.4537L29.7656 16.9815V11.5101C29.7656 10.659 29.4414 9.84846 28.8334 9.24053L20.5251 0.932159C19.9171 0.324229 19.1066 0 18.2555 0H3.38145C1.59819 0 0.13916 1.4185 0.13916 3.20176V33.5982C0.13916 35.341 1.59819 36.8 3.38145 36.8H26.5638C28.3471 36.8 29.7656 35.341 29.7656 33.5982V29.7075L27.2933 32.1797V33.5982ZM20.3224 4.17445L25.5911 9.44317H21.0925C20.6467 9.44317 20.3224 9.07841 20.3224 8.67313V4.17445Z"
      fill="#2EB9FF"
    />
    <path
      d="M32.1225 17.5385L24.127 25.5341L27.5659 28.973L35.5614 20.9775L32.1225 17.5385Z"
      fill="#2EB9FF"
    />
    <path
      d="M21.9031 32.0987L25.0239 31.3692C25.1454 31.3286 25.267 31.2881 25.3886 31.1665L26.2802 30.2749L22.8353 26.83L21.9437 27.7216C21.8626 27.8026 21.7816 27.9242 21.741 28.0863L21.0115 31.207C20.9305 31.7339 21.3763 32.2203 21.9031 32.0987Z"
      fill="#2EB9FF"
    />
    <path
      d="M38.4386 17.1436L36.0069 14.7119C35.7232 14.4282 35.2774 14.4282 34.9532 14.7119L33.4131 16.252L36.858 19.6969L38.3981 18.1569C38.7223 17.8732 38.7223 17.4273 38.4386 17.1436Z"
      fill="#2EB9FF"
    />
  </>
)

export default WriteListIcon
